import { cn } from '#/shared/lib/utils'

interface ToolbarSwapProps {
  showAlt: boolean
  primary: React.ReactNode
  alt: React.ReactNode
  className?: string
}

export function ToolbarSwap({
  showAlt,
  primary,
  alt,
  className,
}: ToolbarSwapProps) {
  return (
    <div className={cn('relative flex items-center', className)}>
      <div
        className={cn(
          'flex items-center gap-2.5 transition-opacity duration-200 max-sm:w-full',
          showAlt ? 'pointer-events-none opacity-0' : 'opacity-100',
        )}
      >
        {primary}
      </div>
      <div
        className={cn(
          'absolute inset-0 flex items-center transition-opacity duration-200',
          showAlt ? 'opacity-100' : 'pointer-events-none opacity-0',
        )}
      >
        {alt}
      </div>
    </div>
  )
}
